import React from 'react';
import './chat.css';

const NewMessagesPill = ({ visible, onClick }) => {
    if (!visible) return null;
    return (
        <button type="button" className="wt-new-pill" onClick={onClick}>
            New messages
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5v14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M19 12l-7 7-7-7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </button>
    );
};

export default NewMessagesPill;
